<template>
    <section class="start-page">
        <div class="start-page__intro">
            <transition name="intro-step-1">
                <div v-if="showIntroAnimation" class="step step-1"></div>
            </transition>
            <transition name="intro-step-2">
                <div v-if="showIntroAnimation" class="step step-2"></div>
            </transition>
            <transition name="intro-step-3">
                <div v-if="showIntroAnimation" class="step step-3"></div>
            </transition>
        </div>

        <transition name="start-page-content" appear>
            <template v-if="showIntroAnimation">
                <div class="start-page__content">
                    <h1 class="headline"><span class="text-din">Gestalte dein</span><br>Wallpaper</h1>
                    <button class="button button--secondary" @click="startGenerator">
                        Los geht's
                    </button>
                    <div class="ie-old-version-disclaimer">
                        Der Wallpaper-Generator ist auf dem Internet Explorer leider nicht verfügbar.
                        Bitte besuche uns mit einem anderen Browser, um Dir ein sipgate Wallpaper für
                        Dein Endgerät zu erstellen.
                    </div>
                </div>
            </template>
        </transition>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                buttonTest: false,
                showIntroAnimation: false
            }
        },
        methods: {
            startGenerator() {
                let vm = this;
                vm.showIntroAnimation = false;
                setTimeout(_ => {
                    vm.$emit('startGenerator');
                }, 500);
            },
        },
        mounted() {
            let vm = this;
            setTimeout(_ => {
                vm.showIntroAnimation = true;
            }, 250);
        }
    }
</script>

<style lang="scss" scoped>

    @import "../assets/scss/animations/fade";
    @import "../assets/scss/animations/sliding";
    @import "../assets/scss/dimensions";

    .start-page {
        display: flex;
        height: 100%;
        align-content: center;

        &__content {
            align-self: center;
            padding: 0 $brand-size-x;
            z-index: 5;

            @media (min-width: 1024px) {
                padding-left: $brand-size-x * 6;
            }

            .button {
                border-color: #FFF;
                font-family: 'PxGroteskRegular';

                &:hover {
                    box-shadow: -10px 8px 0 #A1A1A1;
                }

                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                    display: none;
                }
            }

            .headline {
                font-family: 'PxGroteskBold';
                font-size: 43px;
                font-weight: normal;
                line-height: 1em;
                margin: 0 0 23px 0;

                .text-din {
                    font-size: 45.58px;
                }

                @media (min-width: 1024px) {
                    font-size: 63px;
                    margin-bottom: 30px;

                    .text-din {
                        font-size: 66.78px;
                    }
                }

                @media (min-width: 1920px) {
                    font-size: 83px;
                    margin-bottom: 40px;

                    .text-din {
                        font-size: 87.15px;
                        line-height: 87.15px;
                    }
                }
            }
        }

        .start-page-content-enter-active {
            animation: vueDummy .75s linear forwards;

            .headline {
                animation: slideToRightIn .5s ease-out forwards;
            }

            .button, .ie-old-version-disclaimer {
                animation: slideToRightInWithHalfDelay .75s ease-out forwards;
            }
        }

        .start-page-content-leave-active {
            animation: slideToLeftOut .5s ease-out forwards;
        }

        &__intro {
            bottom: 0;
            height: 100%;
            position: fixed;
            width: 100%;
            z-index: -1;

            .step {
                bottom: 0;
                height: 55vh;
                right: 0;
                position: absolute;
                width: 100%;
                will-change: animation;

                @media (min-width: 768px) {
                    height: 55vh;
                }

                @media (min-width: 1024px) {
                    height: 100vh;
                }
            }

            .step-1 {
                background: transparent url('../assets/intro/intro1.svg') center bottom no-repeat;
                background-size: cover;
            }

            .step-2 {
                background: transparent url('../assets/intro/intro2.svg') center bottom no-repeat;
                background-size: cover;
            }

            .step-3 {
                background: transparent url('../assets/intro/intro3.svg') center bottom no-repeat;
                background-size: cover;
            }
        }
    }

    @keyframes introStepIn {
        0% {
            transform: translateX(100%) translateY(100%);
        }
        100% {
            transform: translateX(0) translateY(0);
        }
    }

    @keyframes introStepOut {
        0% {
            transform: translateX(0) translateY(0);
        }
        100% {
            transform: translateX(100%) translateY(100%);
            opacity: 0;
        }
    }

    .intro-step-1-enter-active {
        animation: introStepIn .5s ease-out forwards;
    }

    .intro-step-2-enter-active {
        animation: introStepIn .75s ease-out forwards;
    }

    .intro-step-3-enter-active {
        animation: introStepIn 1s ease-out forwards;
    }

    .intro-step-1-leave-active {
        animation: introStepOut .5s ease-in forwards;
    }

    .intro-step-2-leave-active {
        animation: introStepOut .5s ease-in forwards;
    }

    .intro-step-3-leave-active {
        animation: introStepOut .5s ease-in forwards;
    }

    .ie-old-version-disclaimer {
        display: none;
        font-size: 13px;
        line-height: 18.2px;
        max-width: 400px;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            display: block;
        }

        @media(min-width: 768px) {
            font-size: 19px;
            line-height: 24px;
        }

        @media(min-width: 1680px) {
            font-size: 26px;
            line-height: 30px;
            max-width: 680px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/StartPage.vue